<template>
  <b-row>
    <b-col md="12">
      <b-card no-body>
        <b-card-body>
          <b-row>
            <b-col md="10">
              <b-input-group>
                <b-form-input
                  v-model="search"
                  placeholder="Satıcı Kartı Ara"
                />
                <b-input-group-append>
                  <b-button
                    v-if="search !== ''"
                    variant="warning"
                    @click="resetSearch"
                  ><FeatherIcon icon="XIcon" /></b-button>
                  <b-button
                    variant="primary"
                    :disabled="search === ''"
                    @click="searchData"
                  ><FeatherIcon icon="SearchIcon" /></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="2">
              <b-button
                to="suppliers/add"
                variant="primary"
                block
              ><FeatherIcon icon="PlusIcon" />
                Ekle</b-button>
            </b-col>
          </b-row>
        </b-card-body>
        <b-table
          responsive="sm"
          :fields="fields"
          :items="dataList"
          striped
        >
          <template #cell(scode)="data">
            {{ data.item.scode }}
          </template>
          <template #cell(name)="data">
            <div>{{ data.item.company }}</div>
            <small>{{ data.item.name }}</small>
          </template>
          <template #cell(city)="data">
            {{ data.item.city }}
          </template>
          <template #cell(phone)="data">
            {{ data.item.phone }}
          </template>
          <template #cell(control)="data">
            <b-button
              :to="'/suppliers/view/' + data.item.id"
              variant="outline-primary"
              size="sm"
            >
              Görüntüle
            </b-button>
          </template>
        </b-table>
        <b-card-footer><b-pagination
          v-model="currentPage"
          :total-rows="dataCount"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination></b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BCardFooter, BPagination, BButton, BFormInput, BInputGroup, BInputGroupAppend, BCardBody,
} from 'bootstrap-vue'

export default {
  name: 'Index',
  components: {
    BCard,
    BTable,
    BRow,
    BCol,
    BCardFooter,
    BPagination,
    BButton,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BCardBody,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 25,
      search: '',
      fields: [
        {
          key: 'scode',
          label: 'Satıcı Kodu',
        },
        {
          key: 'name',
          label: 'Firma Adı / İlgili Kişi',
        },
        {
          key: 'city',
          label: 'Şehir',
        },
        {
          key: 'phone',
          label: 'Telefon',
        },
        {
          key: 'control',
          label: 'Kontrol',
        },
      ],
      dataQuery: {
        select: [
          'suppliers.id AS id',
          'suppliers.scode AS scode',
          'suppliers.company AS company',
          'suppliers.name AS name',
          'suppliers.phone AS phone',
          'cities.title AS city',
        ],
        limit: 25,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      const data = this.$store.getters['suppliers/getSuppliers']
      return data
    },
    dataCount() {
      return this.$store.getters['suppliers/getSuppliersCount']
    },
  },
  watch: {
    currentPage(val) {
      const page = (val - 1) * 25
      this.pagination(page)
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    searchData() {
      this.dataQuery.or_like = {
        'suppliers.scode': this.search,
        'suppliers.company': this.search,
        'suppliers.name': this.search,
        'suppliers.phone': this.search,
      }
      this.getDataList()
    },
    resetSearch() {
      this.dataQuery.or_like = {}
      this.search = ''
      this.getDataList()
    },
    pagination(page) {
      this.dataQuery.start = page
      if (this.dataQuery.start === page) {
        this.getDataList()
      }
    },
    getDataList() {
      this.$store.dispatch('suppliers/suppliersList', this.dataQuery)
    },
  },
}
</script>
